import { render, staticRenderFns } from "./DoctorBasicInfoSection.vue?vue&type=template&id=e9c4da1c"
import script from "./DoctorBasicInfoSection.vue?vue&type=script&lang=js"
export * from "./DoctorBasicInfoSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports